import React from 'react';

import moment from 'moment';
import { Tabs, Value } from './Tabs';
import { HistoricalPerDiemCalendarPeriod, useTrackedHistoricalParams } from '../params';
import { CalendarPeriodFilter, CalendarPeriodFilterFunction } from './CalendarPeriodFilter';
import { ExportModal } from './ExportModal';
import { Compare } from './Compare';

const calendarPeriodFilterFunction: CalendarPeriodFilterFunction = (parsedDates, period) => {
  const dayDiff = parsedDates.endDate?.diff(parsedDates.startDate, 'days') || 0;
  const weekDiff = parsedDates.endDate?.diff(parsedDates.startDate, 'weeks') || 0;
  const monthDiff = parsedDates.endDate?.diff(parsedDates.startDate, 'months') || 0;

  switch (period) {
    case HistoricalPerDiemCalendarPeriod.Day:
      return !!parsedDates.raw.exactDate || dayDiff <= 30;
    case HistoricalPerDiemCalendarPeriod.Week:
      return dayDiff >= 30 && weekDiff <= 30;
    case HistoricalPerDiemCalendarPeriod.Month:
      return monthDiff >= 3 && monthDiff <= 30;
    case HistoricalPerDiemCalendarPeriod.Quarter: {
      const quarterDiff = monthDiff ? monthDiff / 3 : 0;
      const currentYear = moment().startOf('year').format('YYYY-MM-DD');
      return (
        (quarterDiff >= 2 && quarterDiff <= 30) ||
        (parsedDates.raw.startDate === currentYear && parsedDates.raw.endDate === 'today')
      );
    }
    default:
      return false;
  }
};

export const FilterBar: React.FC = () => {
  const { searchParams, setSearchParams } = useTrackedHistoricalParams();
  const { compare, dateRange } = searchParams;

  return (
    <div className="min-h-0 space-y-4 flex flex-col bg-gray-50 shadow-sm p-4 pt-8 sticky top-[-62px] z-10">
      <div className="space-y-2">
        <h1 className="text-2xl font-bold tracking-wide">Per Diem Historical Reporting</h1>
        <h6 className="text-sm text-text-accent-3 font-medium">
          Per diem accruals are based on when the container was gated-in to the empty return
          facility.
        </h6>
      </div>
      <div className="flex justify-between gap-4">
        <div className="gap-4 flex flex-wrap md:flex-nowrap">
          <Tabs
            value={searchParams as Value}
            onChange={(v) => setSearchParams({ ...v, calendarPeriod: null })} // Reset breakdown when changing date range
          />
          <Compare
            compare={compare}
            setCompare={(c) => setSearchParams({ compare: c })}
            dateRange={dateRange}
          />
          <CalendarPeriodFilter
            onChange={(period) => setSearchParams({ ...searchParams, calendarPeriod: period })}
            dateRange={searchParams.dateRange}
            calendarPeriod={searchParams.calendarPeriod}
            filterFunction={calendarPeriodFilterFunction}
          />
        </div>
        <ExportModal />
      </div>
    </div>
  );
};
